export default "__VITE_ASSET__$MAGEU4i__"